import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TableCell,
    TextField,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Tooltip,
  } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { format } from 'date-fns';
import toast from "react-hot-toast";
import { retrieveOfferByIdApi } from '../../../../components/api/OfferApiService';
import { useAuth } from '../../../../auth/AuthContext';

function ApproveOfferButton({ row, approveOffer }) {
  const { user, userLoading } = useAuth();
  const [open, setOpen] = useState(false);
  const [offer, setOffer] = useState(false);

  const handleClickOpen = () => {
     retrieveOfferByIdApi(row?.id)
       .then((response) => {
        setOffer(response?.data);
        setOpen(true);
       })
       .catch((error) => {console.log(error.response?.data);
        setOpen(false);
       })
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApprove = () => {
    approveOffer(offer?.id);
    setOpen(false); 
  };

  const formattedToday = new Date().toISOString().slice(0, 10); // Assuming today's date is formatted as YYYY-MM-DD
  const isPastDeadline = row?.statusDeadline
    ? new Date(row?.statusDeadline) < new Date(formattedToday)
    : false;

  return (
    <>
      <Tooltip title="Approve Offer">
       <IconButton
        color="primary"
        variant="outlined"
        disabled={
          row?.approvalStatus === "Approved" ||
          (isPastDeadline && row?.approvalStatus !== "Declined") ||
            !row?.assignedUserName
        }
        onClick={() => {
          if (user?.email === row?.assignedUserEmail) {
            handleClickOpen();
          } else {
            toast.error("This OFFER is not assigned to you.");
          }
        }}
      >
        <CheckCircleIcon />
  </IconButton>
</Tooltip>
     <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
     <DialogTitle>Approve Offer</DialogTitle>
     <DialogContent>
     <TableContainer component={Paper}
           sx={{
            border: "2px solid #d1dfe8",
            borderRadius: "8px", 
            overflow: "hidden", 
          }}>

      <Table   sx={{
      borderCollapse: "separate", 
      borderSpacing: "0", 
      tableLayout: "fixed",
      width: "100%", 
    }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "15%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Customer
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Buying Grade
            </TableCell>
            <TableCell sx={{ width: "8%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Origin
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Crop
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Nicotine
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sugar
            </TableCell>
            <TableCell sx={{ width: "9%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center",
            fontSize: "0.7rem", }}>
              # Of Cartons
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center",
            fontSize: "0.7rem", }}>
              Net Weight Per Carton
            </TableCell>
            <TableCell sx={{ width: "11%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Volume
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Buying Price
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Final Price
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.stakeholder ? ((offer?.stakeholder?.code || "")+ " "+(offer?.stakeholder?.name || "")) : "" }
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.item?.buyingGrade || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.item?.origin || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.item?.crop || ""}
              />
            </TableCell>


            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.item?.nicotine || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.item?.sugar || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                    offer?.numberOfCases || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                    offer?.netWeightPerCase || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                    offer?.volume || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                    offer?.buyingPrice ? (offer?.buyingPrice + " " + (offer?.buyingPriceCurrency||"")):""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                    offer?.finalOfferPrice ? (offer?.finalOfferPrice + " " + (offer?.finalOfferPriceCurrency||"")):""
                }
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table sx={{
        borderCollapse: "separate",
        borderSpacing: "0",
        tableLayout: "fixed",
        width: "100%",
      }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sales Grade
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sales Origin
            </TableCell>
            <TableCell sx={{ width: "8%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sales Crop
            </TableCell>
            <TableCell sx={{ width: "8%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sales Nicotine
            </TableCell>
            <TableCell sx={{ width: "8%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sales Sugar
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.salesGrade || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.salesOrigin || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.salesCrop || ""}
              />
            </TableCell>


            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.salesNicotine || ""}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={offer?.salesSugar || ""}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
       {/* Display details related to the offer here */}
       <p><strong>Offer ID:</strong> {offer?.id}</p>
       {offer?.comment && <p><strong>Comment:</strong> {offer?.comment || ""}</p>}
       {offer?.commentOne && <p><strong>Comment One:</strong> {offer?.commentOne || ""}</p>}
       {offer?.commentTwo && <p><strong>Comment Two:</strong> {offer?.commentTwo || ""}</p>}
       {offer?.shipment && <p><strong>Shipment:</strong> {offer?.shipment || ""}</p>}
       {offer?.financeCharge && <p><strong>Finance Charge:</strong> {offer?.financeCharge || ""}</p>}
       {offer?.storageCharge && <p><strong>Storage Charge:</strong> {offer?.storageCharge || ""}</p>}
       {offer?.incoterm && <p><strong>Incoterm:</strong> {offer?.incoterm || ""}</p>}
       {/* Add more details as needed */}
       <p>Are you sure you want to approve this offer?</p>
     </DialogContent>
     <DialogActions>
       <Button onClick={handleClose} color="secondary">
         Cancel
       </Button>
       <Button onClick={handleApprove} color="primary" variant="contained">
         Yes, Approve
       </Button>
     </DialogActions>
   </Dialog>
   </>
  );
}

export default ApproveOfferButton;
